module.exports = __webpack_public_path__ + "static/media/cimaa.ec3ba453.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/cimaa.png
// module id = 553
// module chunks = 0